<h2 mat-dialog-title>{{ 'wager.other.enteramount' | translate: 'Enter Amount' }}</h2>
<mat-dialog-content>
  <mat-form-field appearance="outline" class="tw-w-full">
    <input
      placeholder="0"
      matInput type="text"
      [(ngModel)]="amount"
      step="0.01"
      min="0"
      pattern="^\d+(\.\d{1,2})?$"
      amwager3DecimalInput
    >
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end" class="!tw-pt-[0px]">
  <button
    (click)="betAmount()"
    mat-button
    color="primary"
  >
    {{ 'ui.wager.ok' | translate: 'OK' }}
  </button>
  <button mat-button mat-dialog-close>{{ 'generic.cancel' | translate: 'Cancel' }}</button>
</mat-dialog-actions>